import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import {
  ContainerDivs,
  Link
} from '../../components'

import Styles from './HomeEduCenter.css'


@CSSModules(Styles, {allowMultiple:true})
export default class HomeEduCenter extends Component {
  static propTypes = {
    noheader: PropTypes.bool,
  }
  constructor(props){
    super(props)
    this.state = {
      noheader: this.props.noheader || false
    }
  }
  render() {
    const { noheader } = this.state
    const hecIcn = require('../../../static/images/education-center-icon.svg')
    //
    return (
      <div styleName='hec-img-bckgrnd'>
        <ContainerDivs>
          {
            noheader ?
              <div styleName='bumper' /> :
              (
                <div>
                  <Link
                    to={config.routes.eduCenter}
                    title='Action center'
                  >
                    <img
                      src={hecIcn}
                      styleName='hec-icn'
                      alt='Action center'
                    />
                    <h2 styleName='hec-hl'>
                      Action center
                    </h2>
                  </Link>
                  <div styleName='hec-tl'>
                    Learn how to work with your employer to ensure your retirement
                    plan is sustainably invested.
                  </div>
                </div>
              )
          }
          <div styleName='hec-btns'>
            <button styleName='hec-btn-out'>
              <Link
                to={config.routes.eduCenterIndividual}
                title='For employees'
              >
                <div styleName='hec-btn-in btn1'>
                  For employees
                </div>
              </Link>
            </button>
            <button styleName='hec-btn-out'>
              <Link
                to={config.routes.eduCenterPlanAdmins}
                title='For company 401(k) admins'
              >
                <div styleName='hec-btn-in btn2'>
                  For company 401(k) admins
                </div>
              </Link>
            </button>
            <button styleName='hec-btn-out'>
              <Link
                to={config.routes.faqs}
                title='FAQs'
              >
                <div styleName='hec-btn-in btn3'>
                  FAQs
                </div>
              </Link>
            </button>
          </div>
        </ContainerDivs>
      </div>
    )
  }
}

